import { render, staticRenderFns } from "./DistrictModal.vue?vue&type=template&id=77bf5af0&scoped=true&"
import script from "./DistrictModal.vue?vue&type=script&lang=js&"
export * from "./DistrictModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bf5af0",
  null
  
)

export default component.exports